import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import 'firebase/compat/storage';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { getRemoteConfig } from 'firebase/remote-config';
import { connectStorageEmulator, getStorage } from 'firebase/storage';

import { EnvironmentType } from '../config';
import config from '../config/config';

export const STORAGE_URL =
  config.ENVIRONMENT === EnvironmentType.EMULATOR
    ? 'http://localhost:9199/jigsaw-puzzle-universe-web.appspot.com'
    : config.ENVIRONMENT === EnvironmentType.DEVELOPMENT
    ? 'https://storage.googleapis.com/jigsaw-puzzle-universe-web.appspot.com'
    : 'https://storage.googleapis.com/jigsaw-puzzle-universe.appspot.com';

export const DEFAULT_COVER_IMAGE = `${STORAGE_URL}/default_cover.png`;
export const DEFAULT_PROFILE_IMAGE = `${STORAGE_URL}/default_photo.png`;

const firebaseConfig = {
  apiKey: config.API_KEY,
  authDomain: config.AUTH_DOMAIN,
  projectId: config.PROJECT_ID,
  storageBucket: config.STORAGE_BUCKET,
  messagingSenderId: config.MESSAGING_SENDER_ID,
  appId: config.APP_ID,
  measurementId: config.MEASUREMENT_ID,
};

export const app = initializeApp(firebaseConfig);

// NOTE: debug token will be automatically added if it is the local environment
// same debug token is used for all developers (no need for refreshing tokens
// because the debug token will be only used on the local and dev environment)
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
self.FIREBASE_APPCHECK_DEBUG_TOKEN = config.FIREBASE_APPCHECK_DEBUG_TOKEN;

export const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaEnterpriseProvider(config.RECAPTCHA_KEY),
  isTokenAutoRefreshEnabled: true,
});

export const storage = getStorage(app);
export const firestore = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);
export const remoteConfig = getRemoteConfig(app);

if (config.ENVIRONMENT === EnvironmentType.DEVELOPMENT) {
  remoteConfig.settings.minimumFetchIntervalMillis = 0;
} else if (config.ENVIRONMENT === EnvironmentType.PRODUCTION) {
  remoteConfig.settings.minimumFetchIntervalMillis = 30 * 60 * 1000; // 30 minutes.
}

if (config.ENVIRONMENT === EnvironmentType.EMULATOR) {
  connectAuthEmulator(auth, 'http://localhost:9099');
  connectFunctionsEmulator(functions, 'localhost', 5001);
  connectFirestoreEmulator(firestore, 'localhost', 8080);
  connectStorageEmulator(storage, 'localhost', 9199);
}
